import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';

// COMPONENTS
import {
  DialogConfig,
  PaginationConfig,
  IPagination,
  LocationWarehouseGroupApiService,
  IWarehouseGroup,
} from '../../../shared';
import { LocationWarehouseGroupPopupComponent } from '../location-warehouse-group-popup/location-warehouse-group-popup.component';

// INTERFACES

// SHARED

@Component({
  selector: 'lum-location-warehouse-group',
  templateUrl: './location-warehouse-group.component.html',
  styleUrls: ['./location-warehouse-group.component.scss'],
})
export class LocationWarehouseGroupComponent implements OnInit, OnDestroy {
  @Input()
  ftPickAndPackEnabled :boolean = false;

  warehouseGroups$ :Observable<IWarehouseGroup[]>;
  pagination$ :Observable<IPagination>;
  loading$ :Observable<boolean>;

  paginationConfig = PaginationConfig;
  queryParams :{
    [param :string] :string | string[];
  } = {};

  private onDestroy$ = new Subject();

  constructor(
    private dialog :MatDialog,
    private warehouseGroupService :LocationWarehouseGroupApiService,
    private snackbar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.initQueryParams();
    this.getDataFromService();
    this.loadWarehouseGroups();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onPaginationEvent(pagination :PageEvent) :void {
    this.queryParams = {
      ...this.queryParams,
      limit: pagination.pageSize.toString(),
      page: (pagination.pageIndex + 1).toString(),
    };
    this.loadWarehouseGroups();
  }

  onOpenDialog(warehouseGroup ?:IWarehouseGroup) :void {
    const dialogRef = this.dialog.open(LocationWarehouseGroupPopupComponent, {
      data: {
        warehouseGroup,
        ftPickAndPackEnabled: this.ftPickAndPackEnabled,
      },
      width: DialogConfig.sizes.small,
    });

    dialogRef.afterClosed().subscribe((success) => {
      if (success) {
        this.loadWarehouseGroups();
      }
    });
  }

  onDelete(warehouseGroupId :number) :void {
    this.warehouseGroupService
      .delete(warehouseGroupId)
      .pipe(
        tap((response) => {
          this.loadWarehouseGroups();
          this.snackbar.open(response.success, 'Close', { duration: 1500 });
        }),
        catchError((response) => {
          this.snackbar.open(response, 'Close', { duration: 1500 });

          return throwError(() => response);
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe();
  }

  onUpdateFilters(filters :any) :void {
    this.warehouseGroupService.get({
      ...this.queryParams,
      ...filters,
    });
  }

  private initQueryParams() :void {
    this.queryParams = {
      limit: PaginationConfig.perPage.toString(),
      page: PaginationConfig.page.toString(),
      relations:
        'warehouses,defaultWarehouse,appIntegrationAccountInventoryLocation,externallyManagedAppIntegrationAccount',
    };
  }

  private getDataFromService() :void {
    this.warehouseGroups$ = this.warehouseGroupService.warehouseGroups$;
    this.loading$ = this.warehouseGroupService.loading$;
    this.pagination$ = this.warehouseGroupService.pagination$;
  }

  private loadWarehouseGroups() :void {
    this.warehouseGroupService.get(this.queryParams);
  }
}
